export const breakpoint_1 = '560px'
export const breakpoint_2 = '730px'
export const breakpoint_3 = '850px'
export const breakpoint_4 = '1040px'
